import { render } from "./CompanyList.vue?vue&type=template&id=34378b23"
import script from "./CompanyList.vue?vue&type=script&lang=js"
export * from "./CompanyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__